export const specLabelsVi = {
  // Dimension
  length_mm: "Chiều dài (mm)",
  width_mm: "Chiều rộng (mm)",
  height_mm: "Chiều cao (mm)",
  wheelbase_mm: "Chiều dài cơ sở (mm)",
  ground_clearance_mm: "Khoảng sáng gầm (mm)",
  curb_weight_kg: "Trọng lượng không tải (kg)",
  front_cargo_capacity_l: "Thể tích cốp trước (L)",
  cargo_capacity_with_seats_l: "Thể tích cốp (chưa gập ghế) (L)",
  cargo_capacity_folded_seats_l: "Thể tích cốp (gập ghế) (L)",
  gvwr_kg: "Trọng lượng toàn tải (kg)",
  roof_load_capacity_kg: "Tải trọng nóc xe (kg)",
  cargo_box_dimensions: "Kích thước khoang hàng (mm)",

  // Engine
  engine_type: "Loại động cơ",
  drive_type: "Hệ dẫn động",
  motor_count: "Số lượng động cơ",
  max_power_kw: "Công suất tối đa (kW)",
  max_power_hp: "Công suất tối đa (hp)",
  max_torque_nm: "Mô men xoắn cực đại (Nm)",
  max_speed_kmh: "Tốc độ tối đa (km/h)",
  acceleration_0_100_seconds: "Tăng tốc 0-100km/h (giây)",

  // Battery
  battery_type: "Loại pin",
  battery_capacity_kwh: "Dung lượng pin (kWh)",
  available_capacity_kwh: "Dung lượng khả dụng (kWh)",
  wltp_range_km: "Quãng đường WLTP (km)",
  nedc_range_km: "Quãng đường NEDC (km)",
  ac_slow_1phase_kw: "Sạc chậm AC 1 pha (kW)",
  ac_slow_3phase_kw: "Sạc chậm AC 3 pha (kW)",
  dc_fast_charge_kw: "Sạc nhanh DC (kW)",
  fast_charge_time_minutes: "Thời gian sạc nhanh (phút)",
  portable_charger_kw: "Sạc cầm tay (kW)",
  home_charger_kw: "Sạc treo tường (kW)",
  regen_braking: "Phanh tái tạo năng lượng",
  charge_port_standard: "Chuẩn cổng sạc",

  // Suspension & Chassis
  front_suspension: "Treo trước",
  rear_suspension: "Treo sau",
  front_brakes: "Phanh trước",
  rear_brakes: "Phanh sau",
  electronic_parking_brake: "Phanh tay điện tử",
  brake_assist: "Hỗ trợ phanh",
  rim_size_inches: "Kích thước la-zăng (inch)",
  tire_size: "Kích thước lốp",
  power_steering: "Trợ lực lái",
  tire_repair_kit: "Bộ vá lốp",
  jack_kit: "Bộ dụng cụ kích xe",

  // Exterior
  headlight_type: "Loại đèn pha",
  daytime_running_lights: "Đèn ban ngày",
  fog_lights_front: "Đèn sương mù trước",
  fog_lights_rear: "Đèn sương mù sau",
  rear_lights: "Đèn hậu",
  high_mount_brake_light: "Đèn phanh trên cao",
  side_mirror_material: "Chất liệu gương chiếu hậu",
  mirror_heating: "Sấy gương",
  mirror_auto_adjust_reverse: "Tự động điều chỉnh gương khi lùi",
  mirror_memory: "Nhớ vị trí gương",
  door_count: "Số cửa",
  door_handle_type: "Loại tay nắm cửa",
  window_type_description: "Loại cửa sổ",
  front_row_glass_type: "Kính hàng ghế trước",
  rear_row_glass_type: "Kính hàng ghế sau",
  tinted_windows: "Kính tối màu",
  panoramic_sunroof: "Cửa sổ trời toàn cảnh",
  wiper_front: "Gạt mưa trước",
  rear_wiper: "Gạt mưa sau",
  roof_trim: "Thanh giá nóc",
  undercarriage_protection: "Ốp bảo vệ gầm",
  sliding_side_door: "Cửa trượt bên hông",

  // Interior
  seat_material: "Chất liệu ghế",
  driver_seat_adjustment: "Điều chỉnh ghế lái",
  driver_seat_memory: "Nhớ vị trí ghế lái",
  driver_seat_massage: "Massage ghế lái",
  driver_seat_heating: "Sưởi ghế lái",
  driver_seat_ventilation: "Làm mát ghế lái",
  passenger_seat_adjustment: "Điều chỉnh ghế phụ",
  passenger_seat_massage: "Massage ghế phụ",
  passenger_seat_heating: "Sưởi ghế phụ",
  passenger_seat_ventilation: "Làm mát ghế phụ",
  row2_adjustment: "Điều chỉnh hàng ghế 2",
  row2_folding_ratio: "Tỷ lệ gập hàng ghế 2",
  row2_heating: "Sưởi hàng ghế 2",
  row2_ventilation: "Làm mát hàng ghế 2",
  row2_massage: "Massage hàng ghế 2",
  row3_available: "Hàng ghế 3",
  steering_wheel_type: "Loại vô lăng",
  steering_wheel_material: "Chất liệu vô lăng",
  steering_wheel_adjustment: "Điều chỉnh vô lăng",
  steering_wheel_heating: "Sưởi vô lăng",
  air_conditioning_type: "Điều hòa",
  air_quality_control: "Kiểm soát chất lượng không khí",
  air_ionization: "Tạo ion âm",
  cabin_air_filter: "Lọc không khí",
  cabin_partition: "Vách ngăn cabin",

  // Entertainment
  infotainment_screen_inches: "Màn hình giải trí (inch)",
  rear_screen_inches: "Màn hình hàng ghế sau (inch)",
  hud_display: "Hiển thị kính lái (HUD)",
  front_usb_type_a_count: "Cổng USB Type-A (trước)",
  front_usb_type_c_count: "Cổng USB Type-C (trước)",
  row2_usb_type_a_count: "Cổng USB Type-A (sau)",
  row2_usb_type_c_count: "Cổng USB Type-C (sau)",
  row3_usb_type_a_count: "Cổng USB Type-A (hàng 3)",
  twelve_volt_outlets: "Cổng 12V",
  ac_power_outlet: "Cổng nguồn xoay chiều",
  wireless_charging: "Sạc không dây",
  speaker_count: "Số lượng loa",
  speaker_brands: "Thương hiệu loa",
  bluetooth_support: "Hỗ trợ Bluetooth",
  android_auto_support: "Hỗ trợ Android Auto",
  apple_carplay_support: "Hỗ trợ Apple CarPlay",
  wifi_connectivity: "Kết nối Wi-Fi",
  voice_assistant: "Trợ lý ảo",
  charge_payment: "Thanh toán phí sạc",
  auto_diagnostics: "Tự chẩn đoán lỗi",
  vinfast_account_link: "Liên kết tài khoản VinFast",
  account_sync_management: "Đồng bộ và quản lý tài khoản",
  audio_system_upgrade: "Nâng cấp hệ thống âm thanh",

  // Safety
  front_airbags: "Túi khí trước",
  curtain_airbags: "Túi khí rèm",
  side_airbags_front: "Túi khí bên (trước)",
  side_airbags_rear: "Túi khí bên (sau)",
  foot_airbags: "Túi khí bảo vệ chân",
  center_airbags: "Túi khí trung tâm",
  abs_system: "Chống bó cứng phanh (ABS)",
  ebd_system: "Phân phối lực phanh điện tử (EBD)",
  ba_assist: "Hỗ trợ phanh khẩn cấp (BA)",
  esc_system: "Cân bằng điện tử (ESC)",
  tcs_system: "Kiểm soát lực kéo (TCS)",
  hsa_system: "Hỗ trợ khởi hành ngang dốc (HSA)",
  rom_system: "Chống lật (ROM)",
  ess_system: "Tín hiệu dừng khẩn cấp (ESS)",
  tire_pressure_monitoring: "Cảnh báo áp suất lốp",
  auto_door_lock: "Tự động khóa cửa",
  emergency_belt_tensioning: "Căng đai khẩn cấp",
  isofix_child_seat_mount: "Móc ghế trẻ em ISOFIX",
  seatbelt_warning: "Cảnh báo thắt dây an toàn",
  central_door_lock: "Khóa cửa trung tâm",

  // ADAS
  lane_keep_assist: "Hỗ trợ giữ làn",
  lane_departure_warning: "Cảnh báo chệch làn",
  lane_centering: "Hỗ trợ định tâm làn đường",
  traffic_jam_assist: "Hỗ trợ lái xe khi ùn tắc",
  highway_driving_assist: "Hỗ trợ lái xe trên cao tốc",
  adaptive_cruise_control: "Kiểm soát hành trình thích ứng",
  speed_limit_assist: "Hỗ trợ giới hạn tốc độ",
  traffic_sign_recognition: "Nhận diện biển báo giao thông",
  forward_collision_warning: "Cảnh báo va chạm phía trước",
  cross_traffic_alert_rear: "Cảnh báo phương tiện cắt ngang",
  blind_spot_warning: "Cảnh báo điểm mù",
  door_opening_warning: "Cảnh báo mở cửa",
  forward_automatic_braking: "Phanh khẩn cấp tự động",
  emergency_lane_keeping: "Hỗ trợ giữ làn khẩn cấp",
  front_parking_assist: "Hỗ trợ đỗ xe phía trước",
  rear_parking_assist: "Hỗ trợ đỗ xe phía sau",
  rear_camera: "Camera lùi",
  surround_view_monitoring: "Camera 360 độ",
  adaptive_headlights: "Đèn pha thích ứng",
  driver_monitoring_system: "Giám sát người lái",
  
  // Transmission
  transmission_type: "Loại hộp số",
  drive_mode_selection: "Các chế độ lái",
  gear_shifting_buttons: "Nút chuyển số",
  idle_stop_feature: "Tính năng dừng không tải"
};
